import React,{useEffect} from 'react';

const AboutOurTeam = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
  return (
   <>
   <div className="container-fluid" id='about-our-team'>
    <div className="row top-row" >
      <img src="img-data/gallery/Photo/team.jpeg" alt="" style={{width:"100vw"}} />
      
    </div>
    <div className="row first-row">
      <div className="col left-col">
        <h1>Sales &<br /> Marketing</h1>
      </div>
      <div className="col right-col">
        <p>We have a team of highly qualified professionals in field of mechanical and instrumentation equipment who have years of experience in the industry. The focus of our sales team is not only achieving the targets but to provide cost effective and user friendly complete solution to our end client as per their requirements. The entire sales team is upgraded and trained regularly about latest technologies and skills to keep pace with the International Standard. They have been associated from years and always focus on teamwork to provide the best sales & services to the end client.</p>
      </div>
    </div>

    
    <div className="row second-row">
      
      <div className="col left-col">
        <p>Our adept service team excels across engineering sectors, delivering prompt 24/7 assistance. Trained in-house and armed with cutting-edge technology, they execute projects flawlessly and on schedule. Since our inception, our skilled professionals have been integral to our success, meticulously selected by our HR team. They collaborate seamlessly, fostering a harmonious work environment, continuously honing their skills to align with organizational objectives. With a robust after-sales service network comprising over 100 personnel, we ensure unparalleled support tailored to diverse customer requirements.</p>
      </div>
      <div className="col right-col">
        <h1>Service <br /> Team</h1>
        
      </div>
    </div>
    <div className="row third-row">
      <h1>Our Team Includes</h1>
      <hr />
      <p>Expert engineers</p>
      <p>Skilled and semi skilled workers</p>
      <p>Quality controllers</p>
      <p>Sales and marketing professionals</p>
      <p>Warehousing professionals</p>
    </div>
   </div>
   </>
  )
}

export default AboutOurTeam
